export default function KeywordAnalysis({ keywords }) {
const getColor = (percent) => {
  if (percent > 70) return "bg-green-500";
  if (percent > 40) return "bg-yellow-500";
  return "bg-red-500";
};
  if (!keywords) return null;

  return (
    <div className="bg-white p-6 rounded-xl shadow mt-6">

      <h3 className="text-lg font-semibold mb-4">
        🎯 Keyword Match Analysis
      </h3>

      {/* 🔥 MATCH % */}
      <div className="mb-4">
        <p className="font-semibold">
          Match Score: {keywords.matchPercent}%
        </p>

       <div className="w-full bg-gray-200 h-3 rounded mt-2">
  <div
    className={`h-3 rounded ${getColor(keywords.matchPercent)}`}
    style={{ width: `${keywords.matchPercent}%` }}
  />
</div>
      </div>

      {/* ✅ MATCHED */}
      <div className="mb-4">
        <h4 className="text-green-600 text-sm font-semibold">
          ✔ Matched Skills
        </h4>

        <div className="flex flex-wrap gap-2 mt-2">
          {keywords.matched?.map((k, i) => (
            <span key={i} className="bg-green-100 px-2 py-1 text-xs rounded">
              {k}
            </span>
          ))}
        </div>
      </div>

      {/* ❌ MISSING */}
      <div>
        <h4 className="text-red-600 text-sm font-semibold">
          ❌ Missing Skills
        </h4>

        <div className="flex flex-wrap gap-2 mt-2">
          {keywords.missing?.map((k, i) => (
            <span key={i} className="bg-red-100 px-2 py-1 text-xs rounded">
              {k}
            </span>
          ))}
        </div>
      </div>

    </div>
  );
}